import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/analytics-1.4-apis/analytics-1.4-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "reportsuitesave-methods"
    }}>{`ReportSuite.Save methods`}</h1>
    <p><inlineCode parentName="p">{`ReportSuite`}</inlineCode>{` methods that involve updating settings for a report suite. See `}<a parentName="p" {...{
        "href": "get.md"
      }}>{`ReportSuite.Get methods`}</a>{` if you want to simply view any report suite settings.`}</p>
    <p>{`Most `}<inlineCode parentName="p">{`ReportSuite.Save`}</inlineCode>{` methods require an `}<inlineCode parentName="p">{`rsid_list`}</inlineCode>{` parameter as well as the value that you want to update. Include these components as a JSON body in the API call.`}</p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveVirtualReportSuiteSettings" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Accept: application/json" \\
    -H "Content-Type: application/json" \\
    -d "{
            'rsid':'examplevirtualrs',
            'parent_rsid':'examplersid',
            'name':'new vrs',
            'segment_list': [
                '536bfa98e4b06d874b0c927a',
                '536bfa99e4b06d874b0c927f'
            ]
        }"
`}</code></pre>
    <h4 {...{
      "id": "response"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "rsid": "examplersid"
}
`}</code></pre>
    <h2 {...{
      "id": "savebasecurrency"
    }}>{`SaveBaseCurrency`}</h2>
    <p>{`Changes the base currency for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveBaseCurrency`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`base_currency`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The three-letter currency code to assign to the specified report suites. For example, USD = US Dollar.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`1`}</inlineCode>{` if the update operation is successful. Otherwise, returns `}<inlineCode parentName="p">{`0`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "savebaseurl"
    }}>{`SaveBaseURL`}</h2>
    <p>{`Changes the specified base URL to each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveBaseURL`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`base_url`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The base URL that you want to assign to the report suites.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savecalculatedmetrics"
    }}>{`SaveCalculatedMetrics`}</h2>
    <p>{`Saves a list of calculated metrics to each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveCalculatedMetrics`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`calculated_metrics`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`calculated_metric[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of calculated metrics.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the update operation is successful.`}</p>
    <h2 {...{
      "id": "saveclassification"
    }}>{`SaveClassification`}</h2>
    <p>{`Saves a classification for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveClassification`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`date_enabled`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines whether to treat this classification like a campaign.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`element`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the element whose classifications are being retrieved.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Visible name of the classification.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`new_name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`parent_name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contains the parent classification's `}<inlineCode parentName="td">{`div_num`}</inlineCode>{` if this is a sub-classification; otherwise it is `}<inlineCode parentName="td">{`0`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`type`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Classification type. Valid values include `}<inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`numeric`}</inlineCode>{`, `}<inlineCode parentName="td">{`numeric_percent`}</inlineCode>{`, `}<inlineCode parentName="td">{`numeric_currency`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the update operation is successful.`}</p>
    <h2 {...{
      "id": "savecustomcalendar"
    }}>{`SaveCustomCalendar`}</h2>
    <p>{`Creates a custom calendar for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveCustomCalendar`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`anchor_date`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The anchor date for the custom calendar.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`calendar_type`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of calendar to create. Valid values include `}<inlineCode parentName="td">{`gregorian`}</inlineCode>{`, `}<inlineCode parentName="td">{`4-5-4-retail`}</inlineCode>{`, `}<inlineCode parentName="td">{`4-5-4-custom`}</inlineCode>{`, `}<inlineCode parentName="td">{`4-4-5-custom`}</inlineCode>{`, `}<inlineCode parentName="td">{`modified-gregorian`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful. |`}</p>
    <h2 {...{
      "id": "savedatawarehousedisplay"
    }}>{`SaveDataWarehouseDisplay`}</h2>
    <p>{`Saves the data warehouse display for the requested report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveDataWarehouseDisplay`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`data_warehouse_display`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data warehouse display setting. Valid values include `}<inlineCode parentName="td">{`none`}</inlineCode>{`, `}<inlineCode parentName="td">{`all-logins-have-access`}</inlineCode>{`, `}<inlineCode parentName="td">{`grayed-out-tab`}</inlineCode>{`, `}<inlineCode parentName="td">{`admins-only`}</inlineCode>{`, `}<inlineCode parentName="td">{`disabled`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savedefaultpage"
    }}>{`SaveDefaultPage`}</h2>
    <p>{`Updates the a default page setting for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveDefaultPage`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`default_page`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The default Web page. For example, `}<inlineCode parentName="td">{`index.html`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the update operation is successful.`}</p>
    <h2 {...{
      "id": "saveecommerce"
    }}>{`SaveEcommerce`}</h2>
    <p>{`Updates the commerce level for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveEcommerce`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`ecommerce`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables or disables eCommerce.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "saveevars"
    }}>{`SaveEvars`}</h2>
    <p>{`Updates the commerce variables (eVars) for the requested report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveEvars`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`evars`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#evar"
            }}><inlineCode parentName="a">{`evar[]`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of eVars for the specified report suites, including the settings for each eVar.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.|`}</p>
    <h2 {...{
      "id": "saveevents"
    }}>{`SaveEvents`}</h2>
    <p>{`Updates custom events to each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveEvents`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`event`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#event"
            }}><inlineCode parentName="a">{`event[]`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of success events.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savegeosegmentation"
    }}>{`SaveGeoSegmentation`}</h2>
    <p>{`Saves the geosegmentation setting for the requested report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveGeoSegmentation`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`geo_segmentation`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables or disables geoSegmentation reports.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`vista_enabled`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables or disables VISTA geoSegmentation reports.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the update operation is successful.`}</p>
    <h2 {...{
      "id": "saveinternalurlfilters"
    }}>{`SaveInternalURLFilters`}</h2>
    <p>{`Saves internal URL filters for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveInternalURLFilters`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`internal_url_filters`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of internal URLs that you want to exclude from web site tracking.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "saveipaddressexclusion"
    }}>{`SaveIPAddressExclusion`}</h2>
    <p>{`Add an IP address to the IP address exclusion list for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveIPAddressExclusion`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`ip_address`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An IP address that you do not want to include in website tracking. You can use wildcard indicators (`}<em parentName="td">{`) to exclude a range of addresses. For example, 0.0.`}</em>{`.0 would exclude all IP addresses between 0.0.0.0 and 0.0.255.0. You may exclude up to 50 different IP address strings.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`comment`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A comment on the IP address that was excluded.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "saveipobfuscation"
    }}>{`SaveIPObfuscation`}</h2>
    <p>{`Updates the IP address obfuscation settings for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveIPObfuscation`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`ip_obfuscation`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The IP obfuscation setting. Valid values include `}<inlineCode parentName="td">{`obfuscated`}</inlineCode>{`, `}<inlineCode parentName="td">{`none`}</inlineCode>{`, `}<inlineCode parentName="td">{`ip_removed`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful. |`}</p>
    <h2 {...{
      "id": "savelistvariables"
    }}>{`SaveListVariables`}</h2>
    <p>{`Saves list variables for the requested report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveListVariables`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`list_variables`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`list_variable[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data structure that describes the list variables that are configured for a report suite.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`1`}</inlineCode>{` if the operation is successful. Otherwise, returns `}<inlineCode parentName="p">{`0`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "savemarketingchannelcost"
    }}>{`SaveMarketingChannelCost`}</h2>
    <p>{`Updates the marketing channel cost for the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveMarketingChannelCost`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`amount`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`double`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`channel_id`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`channel_type`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`cost_group`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`cost_id`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`end_date`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`dateTime`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`metric`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`start_date`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`dateTime`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`type`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`1`}</inlineCode>{` if the operation is successful. Otherwise, returns `}<inlineCode parentName="p">{`0`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "savemarketingchannelexpiration"
    }}>{`SaveMarketingChannelExpiration`}</h2>
    <p>{`Updates the marketing channel expiration date for the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveMarketingChannelExpiration`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`days`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of days you want to extend the marketing channel expiration date.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`1`}</inlineCode>{` if the operation is successful. Otherwise, returns `}<inlineCode parentName="p">{`0`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "savemarketingchannelrules"
    }}>{`SaveMarketingChannelRules`}</h2>
    <p>{`Updates the marketing channel rules for the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveMarketingChannelRules`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`marketing_channel_rules`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#rsmarketingchannelrulesets"
            }}><inlineCode parentName="a">{`rs_marketing_channel_ruleset`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An updated set of marketing channel rules to apply to each specified report suite.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.|`}</p>
    <h2 {...{
      "id": "savemarketingchannels"
    }}>{`SaveMarketingChannels`}</h2>
    <p>{`Saves one or more marketing channels in the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveMarketingChannels`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`channels`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#marketingchannel"
            }}><inlineCode parentName="a">{`marketing_channel[]`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of marketing channels to save in each specified report suite.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savepaidsearchdetection"
    }}>{`SavePaidSearchDetection`}</h2>
    <p>{`Saves the paid search settings for the requested report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SavePaidSearchDetection`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`search_engine`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data_types.md#searchengineenum"
            }}><inlineCode parentName="a">{`search_engine_enum`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the search engine.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`operator`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Specifies the type of paid search rule. Valid values include `}<inlineCode parentName="td">{`contains`}</inlineCode>{` or `}<inlineCode parentName="td">{`not_contains`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`query_string`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The string value to use when matching a search engine referring URL.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savepermanenttraffic"
    }}>{`SavePermanentTraffic`}</h2>
    <p>{`Updates paid search settings for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SavePermanentTraffic`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`hits_per_day`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The estimated number of hits per day.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`start_date`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The date the traffic level will change.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "saveprops"
    }}>{`SaveProps`}</h2>
    <p>{`Updates the traffic variables for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveProps`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`props`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#prop"
            }}><inlineCode parentName="a">{`prop[]`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of traffic variable objects to assign to the report suites.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "saverealtimesettings"
    }}>{`SaveRealTimeSettings`}</h2>
    <p>{`Selects the metrics and elements (dimensions) on which you want real time reports enabled. Realtime configuration changes take 15 minutes to be reflected in reports.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveRealTimeSettings`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The report suite for which you want to configure real time reports.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`real_time_settings`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#realtimesettings"
            }}><inlineCode parentName="a">{`real_time_settings[]`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide up to three metrics with corresponding elements (dimensions) for which you want to enable real time reporting.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savescheduledspike"
    }}>{`SaveScheduledSpike`}</h2>
    <p>{`Updates scheduled traffic increase settings for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveScheduledSpike`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`start_date`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Date the traffic increase begins.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`end_date`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Date the traffic increase ends.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`hits_per_day`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The expected hits per day during the traffic spike.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.|`}</p>
    <h2 {...{
      "id": "savesitetitle"
    }}>{`SaveSiteTitle`}</h2>
    <p>{`Updates the Site Title (friendly name) setting for the specified report suite.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveSiteTitle`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs. Note that this parameter accepts a list of report suites to maintain consistency between the Admin APIs, however, you should not assign the same site_title to multiple report suites.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`site_title`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The friendly name to apply to the report suites.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "savetimezone"
    }}>{`SaveTimeZone`}</h2>
    <p>{`Updates the time zone setting for each of the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveTimeZone`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`time_zone`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../data-types.md#timezoneenum"
            }}><inlineCode parentName="a">{`time_zone_enum`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The time zone to assign with the report suites.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful.`}</p>
    <h2 {...{
      "id": "saveuniquevisitorvariable"
    }}>{`SaveUniqueVisitorVariable`}</h2>
    <p>{`Updates the unique visitor variable for the specified report suites.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveUniqueVisitorVariable`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of report suite IDs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`unique_visitor_variable`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The commerce variable to use for tracking unique visitors. For example, specify `}<inlineCode parentName="td">{`7`}</inlineCode>{` for eVar7.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the operation is successful. |`}</p>
    <h2 {...{
      "id": "savevideosettings"
    }}>{`SaveVideoSettings`}</h2>
    <p>{`Saves video measurement settings.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveVideoSettings`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Required) A list of report suite IDs. If this is the only parameter specified, then video solution variables are enabled for each report suite.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`content_type_evar`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`eVar that stores the content type for your website or app. Content type is set to "video" automatically for all video views, and to "ad" for all ad views.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`enable_ad_tracking`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables ad tracking solution variables. Enabling this option configures these variables on the report suite, cannot be disabled after it has been enabled.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`enable_chapter_tracking`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables chapter tracking solution variables. Enabling this option configures these variables on the report suite, cannot be disabled after it has been enabled.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rename_custom_variables`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Renames the custom variables to video friendly names, for example Video Views, so that it's clear that they're being used for video measurement.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`use_custom_variables`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If false, video solution variables are enabled for the report suite and the pre-built video reports are configured to use these solution variables. If true, the pre-built video reports are configured to use the provided custom variables instead of solution variables and the last 4 parameters in this list are required.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`video_completes_event`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide a custom event that is not being used, indicates that a user has viewed a complete video or ad.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`video_name_evar`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide a custom eVar that is not being used, this stores the name of the video, as passed to Media.open(). Video Name and Ad Name are automatic classifications based on the data sent on the initial Media.play() call, so you'll see an extra menu level when you view these reports.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`video_time_event`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide a custom event that is not being used, measures the time, in seconds, spent watching a video or ad.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`video_views_event`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide a custom event that is not being used, Indicates that a visitor has viewed some portion of a video or ad. However, it does not provide any information about how much, or what part, of a video the visitor viewed.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns true if the operation is successful.|`}</p>
    <h2 {...{
      "id": "savevirtualreportsuite"
    }}>{`SaveVirtualReportSuite`}</h2>
    <p>{`Create or update a virtual report suite. If the `}<inlineCode parentName="p">{`rsid`}</inlineCode>{` parameter is included, this method updates an existing virtual report suite. If the `}<inlineCode parentName="p">{`rsid`}</inlineCode>{` parameter is excluded, this method creates a new virtual report suite.`}</p>
    <p><inlineCode parentName="p">{`POST https://api.omniture.com/admin/1.4/rest/?method=ReportSuite.SaveVirtualReportSuite`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`rsid`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Requested virtual report suite ID for update.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`parent_rsid`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Parent report suite ID for virtual report suite.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name for the virtual report suite.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`segment_list`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`segment_list[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of segments to be applied to the virtual report suite.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns the Report suite ID string for the created or updated virtual report suite.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      